import React, { Fragment, memo } from 'react';
import { useForm } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { paymentProviderApi } from '@app/store';
import { PaymentProvider, PaymentProviderDTO } from '@app/common';
import { Button, Form, Panel } from '@app/components';
import { PaymentProviderForm } from './PaymentProviderForm';
import { useToast, useTriptych } from '@app/hooks';
import { PaymentProviderCard } from './PaymentProviderCard';
import { PaymentProviderFormValues, transformPaymentProviderFormValuesToPayload, getDefaultFormValues } from './payment-provider-form.helpers';

export const PaymentProviderCreate = memo(() => {
  const toast = useToast();

  const triptych = useTriptych()

  const [create, { isLoading, error: apiErrors }] = paymentProviderApi.useCreateOnePaymentProvidersMutation();

  const formMethods = useForm<PaymentProviderFormValues>({
    resolver: classValidatorResolver(PaymentProviderDTO),
    defaultValues: getDefaultFormValues(PaymentProvider.PAYGREEN),
  });

  const onCreate = async (formValues: PaymentProviderFormValues) => {
    try {
      const paymentProvider = await create(transformPaymentProviderFormValuesToPayload(formValues)).unwrap();

      triptych.close({ mode: 'UPDATE', data: paymentProvider });

      toast.success('Votre prestataire de paiement a bien été ajouté.')
    } catch {
      toast.error('Une erreur est survenue lors de la création de votre prestataire de paiement.')
    }
  }

  return (
    <Fragment>
      <PaymentProviderCard
        formMethods={formMethods}
        toggle={() => triptych.toggle()} />

      <Form formMethods={formMethods} apiErrors={apiErrors}>

        <Panel.Content>

          <Panel.FormContainer>

            <PaymentProviderForm />

          </Panel.FormContainer>

          <Panel.Actions>
            <Button
              title="Retour"
              grow
              large
              bordered
              onPress={() => triptych.close()} />

            <Button
              title="Valider"
              loading={isLoading}
              onPress={formMethods.handleSubmit(onCreate)}
              grow
              large />
          </Panel.Actions>

        </Panel.Content>

      </Form>

    </Fragment>
  );
});
